import React from 'react';
import { useTranslation } from 'react-i18next';

import { fetchTokenAsync } from '../../../store/api/auth';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import Font from '../Font';
import Icon from '../Icon';
import { ErrorSpan, ErrorWrapper } from './styles';

type ErrorHandlerProps = {
  /* currentParameters?: DefaultCustomRatePayload.Parameters; */
  error: string;
};

const ErrorHandler: React.FC<ErrorHandlerProps> = ({
  /* currentParameters, */
  error
}) => {
  const { t } = useTranslation();
  const { consumerPayload } = useAppSelector((state) => state.app);
  const { status: authStatus, value } = useAppSelector((state) => state.auth);
  /*  const { status } = useAppSelector((state) => state.financialCalculator); */

  const dispatch = useAppDispatch();

  const onReloadClick = () => {
    /*  dispatch(resetStatusesAPIs()); */
    if (consumerPayload) {
      /* const pprPayload: DefaultCustomRatePayload = {
        ...consumerPayload
      }; */
      if (authStatus === 'failed') {
        dispatch(fetchTokenAsync());
      } /* else if (status.postProductsRate === 'failed') {
        dispatch(postProductsRate(pprPayload));
      } else {
        dispatch(
          postDefaultCustomRate({
            ...pprPayload,
            parameters: {
              ...currentParameters,
              productKey: pprPayload.parameters?.productKey
            },
            uuid: selectedItem
          })
        );
      } */
    }
  };

  const handleKeyPress = (event: { key: string }) => {
    if (event.key === 'Enter' || event.key === ' ') {
      onReloadClick();
    }
  };

  const global = authStatus === 'failed' && !value;

  return (
    <ErrorWrapper $globalError={global}>
      <Icon
        iconColor="warning"
        iconName="InterfaceAlert"
        iconSize={global ? 'md' : 'xs'}
      />
      <Font
        customConfiguration={{ color: 'warning' }}
        variant={global ? 'bodyRegular' : 'bodySRegular'}
      >
        {error}
      </Font>
      <ErrorSpan
        data-testid="reload-button"
        onClick={onReloadClick}
        onKeyDown={handleKeyPress}
        style={{ cursor: 'pointer' }}
        tabIndex={0}
      >
        <Font
          customConfiguration={{ color: 'warning' }}
          variant="textLinkUnderlined"
        >
          {t('ReloadButton').toUpperCase()}
        </Font>
      </ErrorSpan>
    </ErrorWrapper>
  );
};

export default ErrorHandler;
